import {
	START_FETCH_PLATFORM_SETTING,
	FETCH_PLATFORM_SETTING_SUCCESS,
	FETCH_PLATFORM_SETTING_FAILED,

	UPDATE_PLATFORM_STATUS,
	UPDATE_PLATFORM_SETTING_MAINTENANCE,
} from './action-types';

export function fetchPlatformSettingAction() {
	return {
		type: START_FETCH_PLATFORM_SETTING,
	};
}

export function fetchPlatformSettingSuccessAction(setting) {
	return {
		type: FETCH_PLATFORM_SETTING_SUCCESS,
		setting,
	};
}

export function fetchPlatformSettingFailedAction(error, errorMessage) {
	return {
		type: FETCH_PLATFORM_SETTING_FAILED,
		error,
		errorMessage,
	};
}

export function updatePlatformStatusAction(platform) {
	return {
		type: UPDATE_PLATFORM_STATUS,
		platform,
	};
}

export function updatePlatformSettingMaintenanceAction(maintenance) {
	return {
		type: UPDATE_PLATFORM_SETTING_MAINTENANCE,
		maintenance,
	};
}
